import ExplorerDeleteTemplate from 'src/components/atomic/template/Service/ExplorerDelete'

import {
  ResetExplorerDeleteCheckList,
  setExplorerDeleteCheckList,
} from 'src/store/Reducer/page/explorerPageSlice'
import { RootState } from 'src/store/store'
import { useEffect } from 'react'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'

import useExplorerDeleteEventBus from 'src/hooks/useEventBus/useExplorerDeleteEventBus'

export type ExplorerDeleteDataPropsType = {
  isAllCheckBoxesChecked: boolean
  handleFileDelete: () => void
  handleCheckBox: (idx: number) => void
}
const ExplorerDelete = () => {
  const dispatch = useAppDispatch()
  const { ExplorerDeleteCheckList } = useAppSelector((state: RootState) => state.ExplorerPage)
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const deviceAuth = useAppSelector((state: RootState) => state.deviceAuth)
  const navigate = useNavigate()

  const handleFileDelete = () => {
    dispatch(ResetExplorerDeleteCheckList())
    dispatch(setModalItems({ type: 'deleteData' }))
  }

  const handleCheckBox = (idx: number) => {
    const updatedCheckList = [...ExplorerDeleteCheckList]
    updatedCheckList[idx] = !updatedCheckList[idx]
    dispatch(setExplorerDeleteCheckList(updatedCheckList))
  }

  const isAllCheckBoxesChecked = ExplorerDeleteCheckList.every((value) => value)

  useEffect(() => {
    if (!deviceAuth.File || !Connection) {
      navigate('/explorer')
    }
  }, [deviceAuth.File, Connection, navigate])

  useExplorerDeleteEventBus()

  useEffect(() => {
    return () => {
      dispatch(setExplorerDeleteCheckList([false, false, false, false]))
    }
  }, [dispatch])

  const data: ExplorerDeleteDataPropsType = {
    handleFileDelete,
    handleCheckBox,
    isAllCheckBoxesChecked,
  }

  return <ExplorerDeleteTemplate data={data} />
}
export default ExplorerDelete
